module.exports = __webpack_public_path__ + "293ac3be4a077380cb911b04271f54fe.png";